import React, { useState } from 'react';
import FlexGrid from '@tds/core-flex-grid';
import Text from '@tds/core-text';
import Heading from '@tds/core-heading';
// import Spinner from '@tds/core-spinner';
import Spinner from './spinner';
import { Modal } from 'react-responsive-modal';
import Paragraph from '@tds/core-paragraph';
import RadioCard from '@tds/community-radio-card';
import Button from '@tds/core-button';
import PropTypes from 'prop-types';

const ExportOrdersModal = ({
  isVisible,
  onClose,
  onExportOrders,
  isLoading
}) => {
  const [exportType, setExportType] = useState('all');

  const setChoice = event => {
    setExportType(event.target.value);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      classNames={{
        overlay: 'customOverlay',
        modal: 'customModal'
      }}
    >
      <>
        {isLoading ? <Spinner /> : (
          <>
            <div style={{ width: '90%' }}>
              <Heading level="h2">Select export type</Heading>
            </div>
            <div style={{ height: 20 }} />
            <div style={{ width: 480 }}>
              <FlexGrid>
                <FlexGrid.Row>
                  <FlexGrid.Col xs={12}>
                    <RadioCard
                      label="All Orders"
                      name="all"
                      value="all"
                      checked={exportType === 'all'}
                      onChange={setChoice}
                    >
                      <p>Download a .xlsx file with all orders</p>
                    </RadioCard>
                  </FlexGrid.Col>
                  <div style={{ height: '15px' }} />
                  <FlexGrid.Col xs={12}>
                    <RadioCard
                      label="Filtered Orders"
                      name="filtered"
                      value="filtered"
                      checked={exportType === 'filtered'}
                      onChange={setChoice}
                    >
                      <Paragraph>
                        <Text>Download a .xlsx file with the filtered orders</Text>
                      </Paragraph>
                    </RadioCard>
                  </FlexGrid.Col>
                </FlexGrid.Row>
              </FlexGrid>
            </div>
            <div style={{ height: 20 }} />
            {/* <Spinner
        spinning={isLoading}
        size="small"
        label="Request is processing."
        inline
      > */}

            <Button onClick={() => onExportOrders(exportType)}>
              Export Orders
            </Button>
          </>
        )}
      </>
    </Modal>
  );
};

ExportOrdersModal.propTypes = {
  isVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onExportOrders: PropTypes.func.isRequired
};

ExportOrdersModal.defaultProps = {
  isVisible: false,
  isLoading: false
};

export default ExportOrdersModal;
